module.exports = require("@fortawesome/free-brands-svg-icons");